














































// Libraries
import { Component, Prop, Vue } from "vue-property-decorator";
// Types
import { Quote } from "@/types/quote";
// Components
import CreateOrUpdateModal from "@/components/CreateOrUpdateModal.vue";
import QuoteIcon from "@/assets/scss/svg-icons/QuoteIcon.vue";

@Component({
  components: {
    CreateOrUpdateModal,
    QuoteIcon,
  },
})
export default class SingleQuote extends Vue {
  @Prop({ required: true, type: Object }) readonly quote!: Quote;
  @Prop({ required: true, type: Number }) readonly index!: number;

  showModal = false;
  isDeleting = false;

  deleteQuote(): void {
    this.isDeleting = true;

    this.$store
      .dispatch("deleteQuote", this.quote.id)
      .finally(() => (this.isDeleting = false));
  }
}
